enum ButtonIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

enum ButtonStyles {
  SOLID = 'solid',
  OUTLINE = 'outline',
}

enum ButtonSize {
  SMALL = 'small', //36px Tall
  MEDIUM = 'medium', //48px Tall
}

enum ButtonTypes {
  SUBMIT = 'submit',
  RESET = 'reset',
  BUTTON = 'button',
  SORT_AND_FILTER = 'sort-and-filter',
}

enum ButtonWidth {
  FIT_CONTENT = 'fit-content',
  FULL_WIDTH = 'full-width',
}

enum ButtonTextSize {
  DEFAULT = 'default',
  SM = 'small',
}
enum ButtonVariant {
  DEFAULT = 'default',
  COMPACT_PADDING = 'compact-padding',
}
export { ButtonIconPosition, ButtonVariant, ButtonStyles, ButtonSize, ButtonTypes, ButtonWidth, ButtonTextSize };
